import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { PaymentStatus } from '../constants';

export const reportingRevenueByLocationAPI = async (params: {
  startDate: string;
  endDate: string;
  locationId: string;
  format: string;
  status?: PaymentStatus;
}) => {
  const queryParams = new URLSearchParams();
  queryParams.append('startDate', params.startDate);
  queryParams.append('endDate', params.endDate);
  queryParams.append('locationId', params.locationId);
  queryParams.append('format', params.format);
  if (params.status) {
    queryParams.append('status', params.status);
  }

  const response = await baseAPI.get<string>('/reporting/revenue-by-location', {
    params: queryParams,
    responseType: 'text',
  });
  return response.data;
};

export const useReportingRevenueByLocation = (params: {
  startDate: string;
  endDate: string;
  locationId: string;
  format: string;
  status?: PaymentStatus;
}) => {
  return useQuery({
    queryKey: [
      KEYS.REVENUE_BY_LOCATION,
      params.locationId,
      params.format,
      params.startDate,
      params.endDate,
      params.status,
    ],
    queryFn: () => reportingRevenueByLocationAPI(params),
    enabled: !!params.locationId && !!params.format,
  });
};
